import React, { Component } from 'react';

import { SidebarPortal } from '@plone/volto/components';
import Sidebar from 'iovisit-theme/components/Blocks/Multimedia/Sidebar';
import Body from 'iovisit-theme/components/Blocks/Multimedia/Body';
import { v4 as uuid } from 'uuid';

class Edit extends Component {
  constructor(props) {
    super(props);

    if (!__SERVER__) {
      if (!props.data?.slides || props.data?.slides?.length === 0) {
        props.onChangeBlock(props.block, {
          ...props.data,
          slides: [{ '@id': uuid() }],
        });
      }
    }
  }

  render() {
    if (__SERVER__) {
      return <div />;
    }

    return (
      <>
        <Body {...this.props.data} isEditMode={true} />

        <SidebarPortal selected={this.props.selected}>
          <Sidebar {...this.props} />
        </SidebarPortal>
      </>
    );
  }
}

export default Edit;
